import { CaretRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import WorkspaceImage from "common/components/WorkspaceImage";
import type { Workspace } from "common/types";

export default function WorkspaceItem({ workspace }: { workspace: Workspace }) {
  const { id, name, accounts_count: accountsCount, icon_url } = workspace;

  return (
    <Link
      to={`/workspaces/${id}`}
      className="mb-2 flex items-center gap-2 rounded-3xl border border-black-200 bg-white p-3 transition-colors last:mb-0 hover:bg-black-50"
    >
      <WorkspaceImage id={id} imageSrc={icon_url} />
      <div className="flex flex-col items-start gap-y-1">
        <span className="text-md-bold">{name}</span>

        <span className="text-xs-medium text-black-500">
          {accountsCount
            ? `${accountsCount} account${accountsCount > 1 ? "s" : ""}`
            : "No accounts"}
        </span>
      </div>

      <Button variant="ghost-black" intent="labelIcon" className="ml-auto">
        <CaretRight />
      </Button>
    </Link>
  );
}
